import React from 'react';
import './WhatsAppIcon.css';

const WhatsAppIcon = () => {
    return (
        <a href="https://wa.me/+94718082818" className="whatsapp-icon" target="_blank" rel="noopener noreferrer">
            <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp Icon"/>
        </a>
    );
};

export default WhatsAppIcon;
